import { render, staticRenderFns } from "./subsidiaryAccount.vue?vue&type=template&id=86ebb664&scoped=true"
import script from "./subsidiaryAccount.vue?vue&type=script&lang=js"
export * from "./subsidiaryAccount.vue?vue&type=script&lang=js"
import style0 from "./subsidiaryAccount.vue?vue&type=style&index=0&id=86ebb664&prod&lang=stylus&scoped=true"
import style1 from "./subsidiaryAccount.vue?vue&type=style&index=1&id=86ebb664&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ebb664",
  null
  
)

export default component.exports